
import { computed, defineComponent, onBeforeMount, PropType, reactive, toRaw } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// validation
import useVuelidate from '@vuelidate/core'
import { ScopeValidation } from '@/modules/GatewayModule/validations/Scope.validation'

// classes
import { GatewayScopeT } from '@/core/types/gateway.types'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
        checkbox: Checkbox,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isCreate: {
            type: Boolean,
            default: false,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        isDelete: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Object as PropType<GatewayScopeT>,
            default: null,
        },
    },
    emits: ['create', 'update', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            id: null as number | null,
            scope: null as string | null,
            description: null as string | null,
            isActive: false,
        })

        const state_form$ = useVuelidate(ScopeValidation, state)

        const modalTitle = computed(() => {
            if (props.isCreate) return 'Добавление скоупа'
            if (props.isUpdate) return 'Редактирование скоупа'
            if (props.isDelete) return 'Удаление скоупа'
            return 'modal title'
        })

        const modalConfirmButtonText = computed(() => {
            if (props.isCreate) return 'Добавить'
            if (props.isUpdate) return 'Редактировать'
            if (props.isDelete) return 'Удалить'
            return 'Подтвердить'
        })

        const emitCreate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('create', toRaw(state))
        }

        const emitUpdate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('update', toRaw(state))
        }

        const emitManager = () => {
            if (props.isCreate) emitCreate()
            if (props.isUpdate) emitUpdate()
        }

        const emitCancel = () => {
            emit('cancel')
        }

        onBeforeMount(() => {
            if (!props.initialValue) return

            state.id = props.initialValue.id
            state.scope = props.initialValue.scope
            state.description = props.initialValue.description
            state.isActive = Boolean(props.initialValue.isActive)
        })

        return {
            state,
            state_form$,
            modalTitle,
            modalConfirmButtonText,
            emitManager,
            emitCancel,
        }
    },
})
